<template>
    <div>
        <el-form :model="listQuery" size="small" :inline="true" class="top-form">
            <div>
                <!-- <el-form-item label="所在单位：">
                    <el-select v-model="listQuery.name">
                        <el-option v-for="(item,index) in departmentList" :key="index"
                        :label="item.name"
                        :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="状态：">
                    <el-select v-model="listQuery.shopState">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="停用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="店铺性质：">
                    <el-select v-model="listQuery.publishIs">
                        <el-option label="预发布" :value="1"></el-option>
                        <el-option label="非预发布" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model.trim="listQuery.keyword" placeholder="请输入店铺名称/商家名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getTableList(1)">搜索</el-button>
                    <el-button type="" @click="resetClick">重置</el-button>
                </el-form-item>
            </div>
            <div>
                <el-form-item>
                    <el-button type="primary" @click="addClick">新增店铺</el-button>
                </el-form-item>
            </div>
        </el-form>
        <el-table
            border 
            :header-cell-style="{ 
            fontWeight: 400,
            background:'#F0F5FC',color:'#333333'}"
            :data="tableData" style="width: 100%">
            <el-table-column type="index" label="序号" width="65"> </el-table-column>
            <el-table-column prop="businessName" label="商家名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="businessContact" label="联系人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="businessPhone" label="联系电话" show-overflow-tooltip></el-table-column>
            <el-table-column prop="shopName" label="关联店铺" show-overflow-tooltip></el-table-column>
            <el-table-column prop="publishIs" label="店铺性质" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.publishIs==1">预发布</span>
                    <span v-else-if="scope.row.publishIs==0">非预发布</span>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column prop="shopId" label="租户号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="shopAccount" label="店铺账号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="shopState" label="店铺状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.shopState==1" class="blueColor">启用</span>
                    <span v-else class="redColor">停用</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateTime" label="更新时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateName" label="更新人" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                    <span class="blueColor pointer mr10" @click="editClick(scope.row)">编辑</span>
                    <span class="pointer mr10" :class="scope.row.shopState==1?'redColor':'blueColor'"
                     @click="statusClick(scope.row)">{{scope.row.shopState==1?'停用':'启用'}}</span>
                    <span class="blueColor pointer mr10" @click="resetPassword(scope.row)">重置密码</span>
                    <span class="redColor pointer" @click="deleteClick(scope.row)">删除</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-box">
            <el-pagination
                background
                @current-change="currentChange"
                :current-page.sync="listQuery.current"
                :page-size="listQuery.size"
                layout="total, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {businessList,businessStatus,businessDelete,} from "@/api/merchantManagement.js"
    export default {
        data() {
            return {
                departmentList: [],
                listQuery: {
                    current:1,
                    size:10,
                    shopState: null,
                    publishIs: null,
                    keyword: null
                },
                total: 0,
                tableData: []
            }
        },
        mounted() {
            this.getTableList(1)
        },
        methods: {
            currentChange(val) {
                this.listQuery.current = val;
                this.getTableList()
            },
            getTableList(val) {
                if(val==1) {
                    this.listQuery.current = 1
                }
                businessList(this.listQuery).then(res=>{
                    if(res.code==1) {
                        this.tableData = res.data.records
                        this.total = res.data.total
                    }
                })
            },
            resetClick() {
                this.listQuery.current = 1;
                this.listQuery.shopState = null;
                this.listQuery.publishIs = null;
                this.listQuery.keyword = "";
                this.getTableList();
            },
            addClick() {
                this.$router.push({
                    name: 'addMerchant'
                })
            },
            editClick(row) {
                this.$router.push({
                    name: 'addMerchant',
                    query: {
                        businessId: row.businessId
                    }
                })
            },
            statusClick(row) {
                this.$confirm(
                    `确定要 ${row.shopState == 0 ? "启用" : "停用"} 此用户？`,
                    `${row.shopState == 0 ? "启用" : "停用"}用户`,
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                )
                .then(() => {
                let data = {
                    businessId: row.businessId,
                    shopState: row.shopState==1?0:1,
                };
                businessStatus(data).then((res) => {
                    if (res.code == 1) {
                    this.$message({
                        type: "success",
                        message: "修改成功",
                    });
                    this.getTableList();
                    }
                });
                })
                .catch(() => {});
            },
            deleteClick(row) {
                this.$confirm("确定删除该数据?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    })
                    .then(() => {
                        businessDelete({businessId:row.businessId}).then(res=>{
                            if(res.code==1) {
                                this.$message.success("删除成功！");
                                this.getTableList()
                            }
                        })
                        
                }).catch(()=>{})
            },
            resetPassword(row) {
                this.$confirm("确定重置密码为 'Qaz123!@#'？", "重置密码", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    resetPassword({ userId: row.userId }).then((res) => {
                        if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: "密码重置成功",
                        });
                        this.getTableList();
                        }
                    });
                })
                .catch(() => {});
            }
        }
    }
</script>

<style lang="less" scoped>
.top-form {
    display: flex;
    justify-content: space-between;
}
</style>